import { useCallback } from 'react'
import { LinkButton } from '@/atoms/Button'
import { paths } from '@/constants'
import { useUser } from '@/services/UserService'
import { useLoginUrl } from '@/utils/auth-utils'
import { useTranslate } from '@/utils/translate/translate-client'

const buttonClassNames =
  'w-full md:w-fit justify-center min-w-[121px] px-6 md:px-7 py-[14px] md:py-[17px] max-h-[56px] rounded-[14px]'

export const TorchSubmitButton = ({
  handleSubmitClicked,
  isDark = true,
}: {
  handleSubmitClicked: () => void
  isDark?: boolean
}) => {
  const { t } = useTranslate('create')
  const { isLoggedIn } = useUser()
  const { loginUrl, trackLoginStarted } = useLoginUrl()

  const handleSubmitClickedLogIn = useCallback(() => {
    trackLoginStarted('torch-submit-button')
  }, [trackLoginStarted])

  return (
    <LinkButton
      href={isLoggedIn ? paths.guild.create.torch : loginUrl}
      variant={isDark ? 'white' : 'core-gray-900'}
      className={buttonClassNames}
      onClick={isLoggedIn ? handleSubmitClicked : handleSubmitClickedLogIn}
    >
      <div className="relative flex flex-row items-center justify-center gap-2">
        {t('submitProject', 'Submit Project')}
      </div>
    </LinkButton>
  )
}
